// Node only supports en-US by default, need to polyfill.
if (typeof window === "undefined") {
    // tslint:disable-next-line: no-var-requires
    const IntlPolyfill = require("intl");

    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
}

export default class DateService {
    private dateFormatter: Intl.DateTimeFormat;

    constructor(dateLocale = "es-ES") {
        this.dateFormatter = new Intl.DateTimeFormat(dateLocale);
    }

    public Format(date: string): string {
        if (!date) return undefined;

        const dateInstance = this.createDate(date);
        const formattedDate = this.formatDate(dateInstance);
        return formattedDate;
    }

    private createDate(date: string) {
        return new Date(date);
    }

    private formatDate(date: Date) {
        return this.dateFormatter.format(date);
    }
}
